import React from "react";
import {
	StyleSheet,
	View
} from "react-native";

import Navigator from "./Navigator";
import ReactAudioPlayer from "react-audio-player";

const styles = StyleSheet.create({
	container: {
		flexDirection: "row",
		justifyContent: "flex-end"
	}
});

export default function AudioPlayerWeb(props){
	const renderNavigator = props.back ? (<Navigator url={props.url} back noDownload={props.noDownload} />) : null;
	return (
		<View style={styles.container}>
			{renderNavigator}
			<ReactAudioPlayer src={props.url} controls preload={"auto"} controlsList={"nodownload"} />
		</View>
	);
}
